var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#121B5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 22.5H25.5L26.5 18.5H23V16.5C23 15.47 23 14.5 25 14.5H26.5V11.14C26.174 11.097 24.943 11 23.643 11C20.928 11 19 12.657 19 15.7V18.5H16V22.5H19V31H23V22.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon1);
export default __webpack_public_path__ + "static/media/fb-icon-1.a6b7396c351c46fe2a3eb61be9d2ef25.svg";
export { ForwardRef as ReactComponent };